import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { getMinimalStore } from '../../utils';
import RoleDetails from '../RoleDetails/RoleDetails';
import { RolesDashboard } from '../RolesDashboard';

const queryClient = new QueryClient();
const store = getMinimalStore();

function Routes() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <IntlProvider locale='en'>
          <BrowserRouter basename='/role-recommendations'>
            <Switch>
              <Route exact path='/' component={RolesDashboard} />
              <Route exact path='/role-details/:id' component={RoleDetails} />
            </Switch>
          </BrowserRouter>
        </IntlProvider>
      </Provider>
    </QueryClientProvider>
  );
}

export default Routes;
